// ─────────────────────────────────────────────────────────────
// Independent Residences Gallery Data
// In a real project this would be fetched from a CMS/backend API.
// Each image object mirrors what an admin panel would store.
// ─────────────────────────────────────────────────────────────

export const residenceImages = {
  ongoing: [
    {
      id: "on-1",
      src: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80",
      location: "Kuttikkattoor",
      category: "ongoing",
    },
    {
      id: "on-2",
      src: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&q=80",
      location: "Mavoor Road",
      category: "ongoing",
    },
    {
      id: "on-3",
      src: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=800&q=80",
      location: "Kannur",
      category: "ongoing",
    },
    {
      id: "on-4",
      src: "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=800&q=80",
      location: "Feroke",
      category: "ongoing",
    },
    {
      id: "on-5",
      src: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&q=80",
      location: "Calicut",
      category: "ongoing",
    },
    {
      id: "on-6",
      src: "https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=800&q=80",
      location: "Kuttikkattoor",
      category: "ongoing",
    },
    {
      id: "on-7",
      src: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=800&q=80",
      location: "Mavoor Road",
      category: "ongoing",
    },
    {
      id: "on-8",
      src: "https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=800&q=80",
      location: "Kannur",
      category: "ongoing",
    },
  ],
  completed: [
    {
      id: "cp-1",
      src: "https://images.unsplash.com/photo-1583608205776-bfd35f0d9f83?w=800&q=80",
      location: "Kuttikkattoor",
      category: "completed",
    },
    {
      id: "cp-2",
      src: "https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=800&q=80",
      location: "Calicut",
      category: "completed",
    },
    {
      id: "cp-3",
      src: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80",
      location: "Feroke",
      category: "completed",
    },
    {
      id: "cp-4",
      src: "https://images.unsplash.com/photo-1523217582562-09d0def993a6?w=800&q=80",
      location: "Mavoor Road",
      category: "completed",
    },
    {
      id: "cp-5",
      src: "https://images.unsplash.com/photo-1576941089067-2de3c901e126?w=800&q=80",
      location: "Kannur",
      category: "completed",
    },
    {
      id: "cp-6",
      src: "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=800&q=80",
      location: "Kuttikkattoor",
      category: "completed",
    },
    {
      id: "cp-7",
      src: "https://images.unsplash.com/photo-1598228723793-52759bba239c?w=800&q=80",
      location: "Calicut",
      category: "completed",
    },
    {
      id: "cp-8",
      src: "https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6?w=800&q=80",
      location: "Feroke",
      category: "completed",
    },
  ],
};
